import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { commonSubtitleText } from 'src/modules/utils/constants'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video="https://assets.fubo.tv/marketing/lp/videos/compressed/socca_fubosportsnetwork.mp4"
    title="Watch fubo Sports Network on Fubo"
    subtitle={commonSubtitleText.onAnyDevice}
    networkSet="sports"
    customNetworks={['fsn']}
    showRSN={true}
  />
)
